/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { isMobile } from "react-device-detect";
// import $ from "jquery";

class Event202110_shop_busan extends Component {
  _map = () => {
    window.open(
      "https://map.naver.com/v5/entry/address/14128060.011958305,4184019.4682137705,%EA%B4%91%EC%A3%BC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%8F%99%EA%B5%AC%20%EC%B6%A9%EC%9E%A5%EB%A1%9C%EC%95%88%EA%B8%B8%2012%20%EB%A1%AF%EB%8D%B0%EC%8B%9C%EB%84%A4%EB%A7%88%20%EC%B6%A9%EC%9E%A5%EB%A1%9C%EC%A0%90?c=14128051.6811416,4184025.7909591,19,0,0,0,dh",
      "",
      ""
    );
  };
  render() {
    return (
      <Fragment>
        <div className="event_head">
          <h3>광주점 WEEKEND NIGHT</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div>
          <img src="/img/backimg_1.png" />
        </div>
        <div style={{ cursor: "pointer" }} onClick={this._map}>
          <img src="/img/otako_button.png" />
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202110_shop_busan));
